// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"Terms_wrapperComponent__6Fpiu","content":"Terms_content__SzfOz"};